import * as React from 'react';

import { styled, useThemeProps } from '@mui/material/styles';

import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

export const MuiThemeName = 'OsanoError';

const ErrorRoot = styled(Typography, {
    name: MuiThemeName,
    slot: 'root',
})(({ theme }) => ({
    color: theme.palette.error.main,
    marginTop: theme.spacing(2),
    whiteSpace: 'pre-line',
    '&:empty': {
        display: 'none',
    },
}));

/**
 * Error component for displaying an error message.
 * Theme-aware and supports custom styling via the theme name `OsanoError`.
 */
const Error =
    /** @type {React.ForwardRefExoticComponent<import('@mui/material').TypographyProps>} */ (
        React.forwardRef(function OsanoError(inProps, ref) {
            // The `useThemeProps` hook allows us to hook into the default props for the component defined in our theme.
            const props = useThemeProps({ props: inProps, name: MuiThemeName });
            const { variant, children, ...remain } = props;

            return (
                <ErrorRoot variant={variant || 'caption'} ref={ref} {...remain}>
                    {children}
                </ErrorRoot>
            );
        })
    );

Error.propTypes = {
    children: PropTypes.node,
    variant: PropTypes.string,
};

export default Error;
